import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuxiliaresModule } from '../../../auxiliares/auxiliares.module';
import { CamarasRoutingModule } from './routing';
import { ListadoCamarasComponent } from './listado-camaras/listado-camaras.component';
import { CrearEditarCamaraComponent } from './crear-editar-camara/crear-editar-camara.component';
import { DetallesCamaraComponent } from './detalles-camara/detalles-camara.component';
import { DetallesCamaraInfoComponent } from './detalles-camara-info/detalles-camara-info.component';
import { DetallesCanalesCamarasComponent } from './crear-editar-camara/detalles-canales/detalles-canales.component';
import { JerarquiaClienteComponent } from '../../standalone/jerarquia-cliente/jerarquia-cliente.component';
import { CamarasMultipleComponent } from '../../standalone/camaras-multiple/camaras-multiple.component';
import { PIEZAS_DETALLE } from '../../../componentes/detalle/detalle.components';

@NgModule({
  declarations: [
    ListadoCamarasComponent,
    CrearEditarCamaraComponent,
    DetallesCamaraComponent,
    DetallesCamaraInfoComponent,
    DetallesCanalesCamarasComponent,
  ],
  imports: [
    CommonModule,
    AuxiliaresModule,
    CamarasRoutingModule,
    JerarquiaClienteComponent,
    CamarasMultipleComponent,
    ...PIEZAS_DETALLE,
  ],
})
export class CamarasModule {}
